import SelectBtnField from '@cnamts/vue-dot/src/patterns/SelectBtnField'

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(SelectBtnField,_vm._b({attrs:{"value":_vm.choiceFieldValue,"items":_vm.filteredItems,"multiple":_vm.multiple,"error-messages":_vm.errorMessages},on:{"change":_vm.emitChangeEvent}},'SelectBtnField',_vm.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }